import { Component, OnInit, ViewChild, NgZone } from '@angular/core';
import { MapsAPILoader } from '@agm/core';
import { ServiceType } from 'src/app/models/localization/service-type.model';
import { MasterService } from 'src/app/services/master.service';
import { GisService } from 'src/app/services/gis.services';
import { GisSearchCoordResponseModel } from 'src/app/models/localization/gis-search-coord.response.model';
import { JsonResult } from 'src/app/core/json-result.model';
import { Observable } from 'rxjs';
import { MatSelect } from '@angular/material';
import { ActivatedRoute } from "@angular/router";
import domtoimage from 'dom-to-image';
import { EnvironmentService } from 'src/app/core/services/environment.service';

@Component({
  selector: 'app-service-request-map',
  templateUrl: './service-request.component-map.html',
  styleUrls: ['./service-request.component-map.scss'],
})
export class ServiceRequestMapComponent implements OnInit {
  /*Modo de ventana actual */

  isShowServiceRequest = false;
  isValidate = false;
  isProximidad = false;
  isLoadValidate = false;
  isOpenInfoWindow = false;
  serviceTypeList: ServiceType[];
  title: string = 'AGM project';
  latitude = 0;
  longitude = 0;
  zoom = 18;
  address = 0;
  panorama = null;
  paramUrlMap: any = {
    lat: 0,
    lon: 0,
    ts: ''
  };
  archivoBase64 = "";
  codigoBusqueda = "";
  srcGisBusqueda = "";
  private isQueryParam = 0;
  private geoCoder: any;

  matSelectTypeServiceValue: any;

  @ViewChild('matSelectTypeServices', { static: false }) matSelectTypeServices: MatSelect;
  @ViewChild('search', { static: false }) searchElementRef: any = null;
  @ViewChild('streetviewPano', { static: false }) streetviewPano: any;
  //@ViewChild('mapchild', { static: false }) mapviewchild: any;

  map: google.maps.Map;
  constructor(
    private mapsAPILoader: MapsAPILoader,
    private ngZone: NgZone,
    private masterService: MasterService,
    private gisService: GisService,
    private route: ActivatedRoute,

    private environmentService: EnvironmentService
  ) {


  }


  ngAfterViewInit() {
    this.isQueryParam = parseInt(this.route.snapshot.queryParamMap.get("query"));
    this.isQueryParam = isNaN(this.isQueryParam) ? 0 : this.isQueryParam;
    this.listServiceTypes();
    this.ngChangeTypeServices();


  }

  ngOnInit() {
    //load Places Autocomplete
    this.mapsAPILoader.load().then(() => {
      this.isQueryParam == 0 && this.setCurrentLocation();
      this.geoCoder = new google.maps.Geocoder;
      let autocomplete = new google.maps.places.Autocomplete(this.searchElementRef.nativeElement);
      autocomplete.addListener("place_changed", () => {
        this.ngZone.run(() => {
          //get the place result
          let place: google.maps.places.PlaceResult = autocomplete.getPlace();

          //verify result
          if (place.geometry === undefined || place.geometry === null) {
            return;
          }

          //set latitude, longitude and zoom
          this.latitude = place.geometry.location.lat();
          this.longitude = place.geometry.location.lng();
          this.setInfowStreetView(this.latitude, this.longitude)
          this.getShowVerificateButton();
        });
      });


    });
  }



  ngMapReadyHandler(map: google.maps.Map) {

    this.map = map;
    this.isQueryParam > 0 && this.setDefaultLoadData();

    map.addListener('dblclick', (e: google.maps.MouseEvent) => {
      // Here we can get correct event 
      this.latitude = e.latLng.lat();
      this.longitude = e.latLng.lng();
      this.setInfowStreetView(this.latitude, this.longitude)
      this.getShowVerificateButton();
    });

  }

  ngChangeTypeServices() {
    this.matSelectTypeServices.valueChange.subscribe(value => {
      this.matSelectTypeServiceValue = value;
      this.getShowVerificateButton();


    });
  }

  ngClickShowServiceRequest() {
    if (this.matSelectTypeServiceValue == 'RES' || this.matSelectTypeServiceValue == 'COM') {
      window.open('https://www.calidda.com.pe/atencion-al-cliente/canales-de-atencion?ce=true', '_blank');
    } else {
      /* this.isShowServiceRequest = true;
       this.paramUrlMap = {
         lat: this.latitude,
         lon: this.longitude,
         ts: this.matSelectTypeServiceValue
       }
 */
      /*
      this.paramUrlMap = {
        lat: this.latitude,
        lon: this.longitude,
        ts: this.matSelectTypeServiceValue
      }
      
            window.open('stdln/solicitar-servicio-form', '_blank');
      
            */

      window.open('mailto:Kevin.Ismodes@calidda.com.pe', '_blank');

    }
  }


  ngClickGPSCurrent() {

    this.setCurrentLocation();

  }



  ngClickRedirectSoftnet() {
    window.open(
      `${this.environmentService.softnetUrl}?id=${this.codigoBusqueda}`,
      '_blank' // <- This is what makes it open in a new window.
    );
  }
  private setDefaultLoadData() {
    if (this.isQueryParam > 0) {
      const paramLatitud = Number.parseFloat(this.route.snapshot.queryParamMap.get("lat"))
      const paramLongitud = Number.parseFloat(this.route.snapshot.queryParamMap.get("lon"))
      const paramTypServices = this.route.snapshot.queryParamMap.get("ts")
      this.latitude = paramLatitud;
      this.longitude = paramLongitud;
      this.matSelectTypeServiceValue = paramTypServices;
      this.matSelectTypeServices.value = this.matSelectTypeServiceValue;
      this.setInfowStreetView(this.latitude, this.longitude)
      this.getShowVerificateButton();
    }
  }
  private listServiceTypes() {
    this.masterService.listServiceTypes().subscribe(response => {
      this.serviceTypeList = response.data;
    });
  }
  private getShowVerificateButton() {
    if (this.matSelectTypeServiceValue !== undefined
      && this.latitude != 0 && this.longitude != 0) {

      this.srcGisBusqueda = `https://maps.googleapis.com/maps/api/staticmap?format=jpg&size=600x300&maptype=roadmap&markers=color:red%7Clabel:C%7C${this.latitude},${this.longitude}&key=${this.environmentService.apiKeyGoogleMap}`

      //todo:comment
      var div = document.createElement('div');
      var image = document.createElement('img');
      image.setAttribute('src', this.srcGisBusqueda);
      div.appendChild(image)

      document.body.classList.add('overflow-hidden')
      document.body.appendChild(div)

      //<img id="captureimage"[src]="srcGisBusqueda"> -
      //this.mapviewchild.nativeElement)
      setTimeout(() =>
        domtoimage.toPng(image)
          .then((dataUrl) => {
            div.remove()
            document.body.classList.remove('overflow-hidden')
            const imagenBase64 = dataUrl.replace(/^data:image\/\w+;base64,/, "");
            this.archivoBase64 = imagenBase64;
            this.getPointsGis().subscribe((response: JsonResult<GisSearchCoordResponseModel>) => {
              const pregioGas = response;

              this.isValidate = pregioGas.data.brindarGas == 1 && pregioGas.data.frenteRed == "SI";
              this.isProximidad = this.isValidate ? false : (pregioGas.data.proximidad.toLowerCase() == "si");
              this.codigoBusqueda = response.data.codigoBusqueda;
              //this.isValidate = pregioGas.data.brindarGas == 0 && pregioGas.data.frenteRed == "SI";
              this.isLoadValidate = true
            })

          }).cath((error) => {
            console.log(error)
          })
        , 1000)

      //private getPointsGis(): GisSearchCoordResponseModel {



    }
  }
  private getAddress(latitude: number, longitude: number) {
    this.geoCoder.geocode({
      'location': { lat: latitude, lng: longitude }

    }, (results: any, status: any) => {

      if (status === 'OK') {
        if (results[0]) {
          this.address = results[0].formatted_address;

          this.searchElementRef.nativeElement.value = this.address;
          var geolocpoint = new google.maps.LatLng(latitude, longitude);
          this.map.setCenter(geolocpoint);//line added for setting center
        } else {
          window.alert('No results found');
        }
      } else {
        window.alert('Geocoder failed due to: ' + status);
      }

    });
  }

  private getPointsGis(): Observable<JsonResult<GisSearchCoordResponseModel>> {

    return this.gisService.SearchPrediosCoordenadas(this.latitude, this.longitude, this.matSelectTypeServiceValue
      , this.searchElementRef.nativeElement.value
      , this.archivoBase64)

  }
  // Get Current Location Coordinates
  private setCurrentLocation() {
    if ('geolocation' in navigator) {
      navigator.geolocation.getCurrentPosition((position) => {
        this.latitude = position.coords.latitude;
        this.longitude = position.coords.longitude;

        this.getAddress(this.latitude, this.longitude);
        this.setInfowStreetView(this.latitude, this.longitude);

        this.matSelectTypeServiceValue != null && this.getShowVerificateButton();

      });
    }
  }
  private setInfowStreetView(lat, lng) {
    let center = { lat, lng };
    let panorama = new google.maps.StreetViewPanorama(
      this.streetviewPano.nativeElement, {
      position: center,
      pov: { heading: 34, pitch: 10 },
      scrollwheel: false
    });
    this.isOpenInfoWindow = true;
    this.map.setStreetView(panorama);

  }
}